import type { Lang } from '@/i18n/locale';

export interface FitnessWalkingResetCopy { readonly cue: string; readonly notRepetitionLabel: string; }
/** Literal nine-language reset draft d9623f41. Visual only; no coach/audio or workout authority. */
const copy: Readonly<Record<Lang, FitnessWalkingResetCopy>> = {
  "EN": {
    "cue": "Return to the starting position.",
    "notRepetitionLabel": "Reset. Not a repetition."
  },
  "PT-BR": {
    "cue": "Retorne à posição inicial.",
    "notRepetitionLabel": "Retorno. Não conta como repetição."
  },
  "NL": {
    "cue": "Keer terug naar de startpositie.",
    "notRepetitionLabel": "Terug naar het begin. Dit telt niet als herhaling."
  },
  "DE": {
    "cue": "Kehre in die Ausgangsposition zurück.",
    "notRepetitionLabel": "Rückweg. Zählt nicht als Wiederholung."
  },
  "IT": {
    "cue": "Torna alla posizione iniziale.",
    "notRepetitionLabel": "Ritorno. Non conta come ripetizione."
  },
  "FR": {
    "cue": "Revenez à la position de départ.",
    "notRepetitionLabel": "Retour. Ne compte pas comme une répétition."
  },
  "PL": {
    "cue": "Wróć do pozycji wyjściowej.",
    "notRepetitionLabel": "Powrót. Nie liczy się jako powtórzenie."
  },
  "BG": {
    "cue": "Върнете се в изходна позиция.",
    "notRepetitionLabel": "Връщане. Не се брои за повторение."
  },
  "ES": {
    "cue": "Vuelve a la posición inicial.",
    "notRepetitionLabel": "Regreso. No cuenta como repetición."
  }
};
for (const value of Object.values(copy)) Object.freeze(value);
Object.freeze(copy);
export function getFitnessWalkingResetCopy(language: Lang): FitnessWalkingResetCopy { return copy[language] ?? copy.EN; }
